import React, { useState, useEffect } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import { useQuery } from "react-query";
import {
  deleteConversations,
  getConversations,
} from "../../../MyApi/conversations";
import PaginationComponent from "../../../Components/UI/pagnationComponent";

import TableActions from "../../../Components/UI/table/TableActions";
import TicketList from "../../../Components/technicalSupport/ticktes/ticketsList";
import ResolutionPanel from "../../../Components/technicalSupport/ResolutionPanel";
import OrderHeader from "../../../Components/technicalSupport/OrderHeader";
import OrderTimeline from "../../../Components/technicalSupport/OrderTimeline";
import ActionHistoryCards from "../../../Components/technicalSupport/ActionHistoryCards";
import CustomerInfo from "../../../Components/technicalSupport/customerInfo";
import StoreInfo from "../../../Components/technicalSupport/storeInfo";
import CurioerInfo from "../../../Components/technicalSupport/curioerInfo";
import OrderItems from "../../../Components/technicalSupport/OrderItems";
import { showOrders } from "../../../MyApi/orders";
import { Spinner } from "reactstrap";
import MultiStoreOrder from "../../../Components/technicalSupport/MultiStoreOrder";
import StatusBadge from "../statusBadge";

const SupportPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedTicket, setSelectedTicket] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({ type: "user", status: "" });
  const [userId, setUserId] = useState("");

  const { data, isLoading, error, refetch } = useQuery(
    ["getconversations", filters.type, currentPage, searchTerm, filters.status],
    () =>
      getConversations("support", filters.type, currentPage, filters.status),
  );

  const supportData = data?.data?.conversations || [];
  const total = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 1;
  
  // Reset pagination when filters or search term change
  useEffect(() => {
    setCurrentPage(1);
  }, [filters.type, filters.status, searchTerm]);

  // Fetch order details when order_id exists
  const {
    data: orderData,
    isLoading: orderLoading,
    refetch: refetchOrder,
  } = useQuery(["showOrders", orderId], () => showOrders(orderId), {
    enabled: !!orderId && orderId !== null,
  });

  const supportStoresColumns = [
    {
      label: "معرف التذكرة",
      render: (row) => <div className="text-green">{row.id}</div>,
    },
    { label: "اسم العميل", accessor: "vendor.full_name" },

    { label: " رقم الجوال", accessor: "vendor.phone" },
    { label: "آخر رسالة", accessor: "last_message.content" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge
          status={
            row?.status === "ACTIVE"
              ? "active"
              : row?.status === "PENDING"
                ? "pending"
                : "inActive"
          }
          statusLabel={row.status}
        />
      ),
    },

    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={`${process.env.PUBLIC_URL}/curior/edit/${row.id}`}
          id={row.id}
          viewPermission={"view_conversation"}
          deletePermission={"delete_conversation"}
          deleteFn={deleteConversations}
          queryKey={"delete_conversation"}
        />
      ),
    },
  ];

  const onShowOrderDetails = (id) => {
    if (!id) {
      setOrderId(null);
      return;
    }
    setOrderId(id);
  };
  // const isMultiStore = orderData?.data?.order?.is_multistore;

  return (
    <div class="container-fluid">
      <div class="row">
        <HeaderBar
          title={"مركز الدعم"}
          content={"إدارة طلبات الدعم ومحادثات النظام"}
        />
            <div className="col-xxl-3 p-0">
              <TicketList
                selectedTicket={selectedTicket}
                isLoading={isLoading}
                tickets={supportData.map((c) => {
                  // Map the data based on the type
                  let customerInfo = {};
                  if (filters.type === "courier" && c.couier) {
                    customerInfo = {
                      customer_name: c.couier.name || "",
                      phone: c.couier.phone || "",
                    };
                  } else if (filters.type === "vendor" && c.vendor) {
                    customerInfo = {
                      customer_name: c.vendor.full_name || "",
                      phone: c.vendor.phone || "",
                    };
                  } else if (c.user) {
                    customerInfo = {
                      customer_name: c.user.name || "",
                      phone: c.user.phone || "",
                    };
                  }

                  return {
                    ticketID: c.id.toString(),
                    customer_name: customerInfo.customer_name,
                    issue_type: c.last_message?.content || "",
                    status_badge: c.status,
                    Priority: c.priority || "",
                    time: c.start_time || "",
                    type: filters.type,
                    entity_id:
                      filters.type === "courier"
                        ? c.couier?.id
                        : filters.type === "vendor"
                          ? c.vendor?.id
                          : c.user?.id,
                    store_id:
                      filters.type === "vendor" ? c.vendor.store?.id : null,
                  };
                })}
                onSelectTicket={(t) => setSelectedTicket(t)}
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                statusOptions={[
                  { value: "Active", label: "Active" },
                  { value: "Pending", label: "Pending" },
                  { value: "INACTIVE", label: "Inactive" },
                ]}
                onFilterChange={(key, value) =>
                  setFilters((f) => ({ ...f, [key]: value }))
                }
                currentPage={currentPage}
                totalPages={total}
                onPageChange={setCurrentPage}
                total={total}
                perPage={lastPage}
              />
              {/* {total  && (
                <PaginationComponent
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  totalItems={total}
                  itemsPerPage={lastPage}
                />
              )} */}
            </div>
            <div className="col-xxl-9 p-0">
              <ResolutionPanel
                setUserId={setUserId}
                userId={userId}
                refetch={refetch}
                refetchOrder={refetchOrder}
                orderId={orderId}
                orderData={orderData}
                ticket={selectedTicket}
                onShowOrderDetails={onShowOrderDetails}
                orderItems={
                  orderData?.data?.order?.is_multistore
                    ? orderData?.data?.order.children.flatMap(
                        (child) => child.items,
                      ) || []
                    : orderData?.data?.order?.items
                }
                onResolve={(t) => {
                  console.log("resolve", t);
                  // call API to mark resolved
                }}
              />
            </div>
            {/* <div className="col-xxl-5">
              {orderLoading ? (
                <div className="text-center text-muted py-5">
                  جاري التحميل <Spinner />
                </div>
              ) : (
                <>
                  <OrderHeader
                    orderData={orderData}
                    isMultiStore={isMultiStore}
                  />
                  <OrderTimeline orderData={orderData} />
                  {isMultiStore ? null : (
                    <ActionHistoryCards orderData={orderData} />
                  )}
                  <OrderItems orderData={orderData} />
                  <MultiStoreOrder orderData={orderData} />
                </>
              )}
            </div> */}

      </div>
    </div>
  );
};

export default SupportPage;
